import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-065eb055"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-container" }
const _hoisted_2 = {
  ref: "iframeRef",
  style: {"width":"100%"},
  src: "/timeline.html"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", _hoisted_2, null, 512)
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}